import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { LucideAngularModule } from 'lucide-angular';
import type { BlogPublicCategoryNodeDto } from '@/api';
import { blogCategoryLink } from './blog-sidebar-nav.utils';

@Component({
  selector: 'app-blog-sidebar-nav-tree',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, LucideAngularModule, BlogSidebarNavTreeComponent],
  templateUrl: './blog-sidebar-nav-tree.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlogSidebarNavTreeComponent {
  readonly nodes = input.required<BlogPublicCategoryNodeDto[]>();
  readonly depth = input(0);
  readonly expandedSlugs = input.required<ReadonlySet<string>>();
  readonly activeCategorySlug = input<string | null>(null);

  readonly toggleExpand = output<string>();
  readonly categoryNavigate = output<void>();

  protected categoryLink(slug: string): string[] {
    return blogCategoryLink(slug);
  }

  protected isExpanded(slug: string): boolean {
    return this.expandedSlugs().has(slug);
  }

  protected isSelected(slug: string): boolean {
    return this.activeCategorySlug() === slug;
  }

  protected hasChildren(node: BlogPublicCategoryNodeDto): boolean {
    return node.children.length > 0;
  }

  protected onToggle(slug: string, event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.toggleExpand.emit(slug);
  }

  protected onCategoryClick(): void {
    this.categoryNavigate.emit();
  }
}
